import { TakePaymentModal, TakePaymentModalByPmsId } from "./TakePaymentModal";
import { show } from "@ebay/nice-modal-react";

/** Display the Take a Payment modal dialog. */
export async function showTakePaymentModal(pmsId: string | undefined = undefined) {
    if (!pmsId) {
        await show(TakePaymentModal);
    } else {
        await show(TakePaymentModalByPmsId, { pmsId });
    }
}
